type Arguments = unknown[];
type Composable = AnyFunction;
type Composed<TResult> = AnyFunction<TResult>;

export function compose<TResult>(...fns: Composable[]): Composed<TResult> {
  return fns.reduceRight(
    (prevFn, nextFn) =>
      (...args: Arguments) =>
        nextFn(prevFn(...args)),
    (value: unknown) => value
  ) as Composed<TResult>;
}
